// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/bank_switch/firstparty/v1/update_movable_payment.proto

/* oxlint-disable */
import { ApiMovablePayment, ApiStatus, apiStatusFromJSON, apiStatusToJSON } from "./movable_payment";

/** Request to update the status of a movable payment. */
export interface ApiUpdateMovablePaymentRequest {
  /** Unique identifier of the movable payment (from path parameter). */
  readonly id: string;
  /** New status for the movable payment. Only MOVED or DISMISSED are accepted. */
  readonly status: ApiStatus;
}

/** Response containing the updated movable payment. */
export interface ApiUpdateMovablePaymentResponse {
  /** The updated movable payment. */
  readonly movablePayment: ApiMovablePayment | null;
}

export const ApiUpdateMovablePaymentRequest: MessageFns<ApiUpdateMovablePaymentRequest> = {
  fromJSON(object: any): ApiUpdateMovablePaymentRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.STATUS_UNSPECIFIED,
    };
  },

  toJSON(message: ApiUpdateMovablePaymentRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    return obj;
  },
};

export const ApiUpdateMovablePaymentResponse: MessageFns<ApiUpdateMovablePaymentResponse> = {
  fromJSON(object: any): ApiUpdateMovablePaymentResponse {
    return {
      movablePayment: isSet(object.movable_payment) ? ApiMovablePayment.fromJSON(object.movable_payment) : null,
    };
  },

  toJSON(message: ApiUpdateMovablePaymentResponse): unknown {
    const obj: any = {};
    if (message.movablePayment !== undefined && message.movablePayment !== null) {
      obj.movable_payment = ApiMovablePayment.toJSON(message.movablePayment);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
